export default __webpack_public_path__ + "static/media/logo_white.b7c9a3eb.svg";